import { render, staticRenderFns } from "./liffcooperationItem.vue?vue&type=template&id=8ee21442&"
import script from "./liffcooperationItem.vue?vue&type=script&lang=js&"
export * from "./liffcooperationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports